/**
 * senchado-product-related — 「この商品を見た方はこちらも」動的レコメンド
 *
 * Shopify recommendations API（Ajax・テーマ非依存・非Plus可）:
 *   GET /recommendations/products.json?product_id={id}&limit={n}&intent=related
 * 0件・失敗時はセクションを hidden のまま（穴を開けない）。
 * 価格: Ajax系JSON の price は minor unit ×100（セント相当）で返る（2026-07-21 実測）。
 *   例: /recommendations/products.json の price=1256300 は実売¥12,563。円換算は /100 + Math.round。
 */
(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(str) { return escapeHtml(str); }
  function money(v) { return '¥' + Math.round(Number(v || 0) / 100).toLocaleString('ja-JP'); }
  // Shopify CDN は width/height/crop で任意サイズを取得できる。カードは正方形
  // （CSS: aspect-ratio 1/1 + object-fit cover）なので、サーバ側で正方形クロップして
  // 配信する。これで縦長・横長どちらのソースでも枠いっぱいの実解像度を確保できる。
  function sized(url, width) {
    if (!url) return '';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + width + '&height=' + width + '&crop=center';
  }
  // DPR2-3 のスマホでもカード枠（168〜200px）が粗く見えないよう解像度候補を並べる。
  function srcset(url) {
    if (!url) return '';
    return [300, 450, 600, 900].map(function (w) {
      return sized(url, w) + ' ' + w + 'w';
    }).join(', ');
  }

  function cardHtml(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var imgHtml = img
      ? '<img class="senchado-related__img" src="' + escapeAttr(sized(img, 600)) +
          '" srcset="' + escapeAttr(srcset(img)) +
          '" sizes="(min-width: 750px) 200px, 168px"' +
          ' alt="" loading="lazy" decoding="async" width="600" height="600">'
      : '<span class="senchado-related__img senchado-related__img--empty" aria-hidden="true"></span>';
    return '<a class="senchado-related__card" href="' + escapeAttr(p.url) + '">' +
      imgHtml +
      '<span class="senchado-related__name">' + escapeHtml(p.title) + '</span>' +
      '<span class="senchado-related__price">' + escapeHtml(money(p.price)) + '<span class="senchado-related__tax">（税込）</span></span>' +
    '</a>';
  }

  function boot() {
    document.querySelectorAll('[data-senchado-related]').forEach(function (root) {
      if (root.dataset.booted) return;
      root.dataset.booted = '1';
      var pid = root.dataset.productId;
      var limit = parseInt(root.dataset.limit, 10) || 8;
      var rail = root.querySelector('[data-related-rail]');
      if (!pid || !rail) return;

      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=' + limit + '&intent=related')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var products = (data && data.products) || [];
          products = products.filter(function (p) {
            if (!p || !p.url || p.available === false) return false;
            // BOX定期便ミラー子商品を関連レコメンドに出さない。Shopify recommendations APIは
            // オンラインストア公開商品を購買共起で拾うため、ミラー公開後に混入し得る（保険の二重防御）。
            if (p.type === '定期便BOX子') return false;
            var tags = p.tags;
            if (Array.isArray(tags) ? tags.indexOf('_box_child') !== -1
              : (typeof tags === 'string' && tags.indexOf('_box_child') !== -1)) return false;
            return true;
          });
          if (!products.length) return;
          rail.innerHTML = products.map(cardHtml).join('');
          root.hidden = false;
        })
        .catch(function () { /* 失敗時は非表示のまま */ });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
